import logo from '../Assets/RSIDE.png';
import './LoadingScreen.css';

function LoadingScreen({ message = 'Loading...' }) {
  return (
    <div className="ls-overlay">
      <div className="ls-card">
        <div className="ls-logo-wrap">
          <div className="ls-ring" />
          <img src={logo} alt="RSIDE" className="ls-logo" />
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
